/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const addGroupPayoutConfig = {
  FIELDS: [
    {
      type: 'text',
      compProps: {
        id: 'countryName',
        label: 'Country Name',
        required: true,
        placeholder: 'Enter your Country Name',
        errorText: 'Country Name is required',
      },
    },
    {
      type: 'choosePhoto',
      compProps: {
        id: 'logo',
        label: 'Country Logo',
        errorText: 'Please choose Country Logo',
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'description',
        label: 'description',
        required: true,
        placeholder: 'Enter Description',
        errorText: 'Description is required',
      },
    },
  ],
  layout: [['countryName'], ['logo'], ['description']],
};
